import React, { useState } from "react";
import { useModal } from "../../../contexts/modal/hooks";
import { useActiveEditContext } from "../../../hooks/use_active_edit_context";
import { ChooseActionStep } from "./choose_action_step";
import { ChooseActionButtons } from "./choose_action_buttons";
import { NameRunStep } from "./name_run_step";
import { NameRunButtons } from "./name_run_buttons";

export const NameRunStepContainer = ({
  onDiscard,
  onTriggerRun,
}: {
  onDiscard: () => void;
  onTriggerRun: (runName: string) => void;
}) => {
  const { closeModal } = useModal();
  const [runName, setRunName] = useState("");
  const [error, setError] = useState("");

  const handleDiscard = () => {
    onDiscard();
    closeModal();
  };

  const handleTriggerRun = (runName: string) => {
    onTriggerRun(runName.trim());
    closeModal();
  };

  return (
    <>
      <NameRunStep
        runName={runName}
        setRunName={setRunName}
        error={error}
        setError={setError}
      />
      <NameRunButtons
        onTriggerRun={handleTriggerRun}
        onDiscard={handleDiscard}
        runName={runName}
        setError={setError}
      />
    </>
  );
};

export const useForceUserEditConclude = () => {
  const { openModal } = useModal();
  const { saveEditsAndTriggerRun, discardChanges } = useActiveEditContext();

  const openForceUserEditModal = (startAtStep: number = 0) => {
    const handleDiscard = () => {
      discardChanges();
    };

    const handleTriggerRun = (runName: string) => {
      saveEditsAndTriggerRun(runName);
    };

    openModal({
      disableStepViewer: true,
      maxWidth: "sm",
      currentStepIndex: startAtStep,
      steps: [
        {
          id: "step1",
          title: "Unsaved Changes",
          content: <ChooseActionStep />,
          customActions: (
            <ChooseActionButtons
              onDiscard={handleDiscard}
              onTriggerRun={handleTriggerRun}
            />
          ),
        },
        {
          id: "step2",
          title: "Name Your Run",
          content: (
            <NameRunStepContainer
              onDiscard={handleDiscard}
              onTriggerRun={handleTriggerRun}
            />
          ),
          disableActions: true,
        },
      ],
    });
  };

  return { openForceUserEditModal };
};
